import { FC } from 'react';

import { Loader, LoaderProps, rem } from '@mantine/core';

const LoaderSizeMapping: { [key: string]: string } = {
  xs: rem(12),
  sm: rem(12),
  md: rem(12),
  lg: rem(16),
  xl: rem(16)
};

const InputLoader: FC<LoaderProps> = ({ size, ...rest }) => {
  return <Loader size={LoaderSizeMapping[size as string]} {...rest} />;
};

export { InputLoader };
